// Assets
import { MapMarkerSvg } from 'src/svgs'

// Styles
import styles from './Marker.module.scss'

const Marker = () => (
  <div className={styles.marker}>
    <MapMarkerSvg />
  </div>
)

export default Marker
